import { DesignTokenColor } from "@src/theme";

export const ALL_ICONS = [
  'arrow-up-from-bracket',
  'calendar',
  'calendar-check',
  'caret-down-solid',
  'caret-up-solid',
  'check',
  'chevron-left',
  'chevron-right',
  'chevron-down',
  'chevron-up',
  'circle-dollar-to-slot',
  'clock',
  'exclamation-triangle',
  'eye-regular',
  'info-circle',
  'list-check',
  'location-crosshairs',
  'search',
] as const;

export type IconName = (typeof ALL_ICONS)[number];

export type IconColor =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'primary'
  | 'secondary'
  | 'tertiary';

export type IconVariant = 'light' | 'dark' | 'custom';

export type IconProps = IconColors & {
  name: IconName;
  iconSize?: `${number}px`;
  boxSize?: `${number}px`;
};

type IconColors = LightColor | DarkColor | CustomColor;

export type LightColor = {
  variant?: 'light';
  color?: IconColor;
  backgroundColor?: never;
};

export type DarkColor = {
  variant?: 'dark';
  color?: IconColor;
  backgroundColor?: never;
};

export type CustomColor = {
  variant?: 'custom';
  color?: DesignTokenColor | string;
  bgColor?: DesignTokenColor | string;
};
